<script>
export default {
  name: 'AnalyticsLandingPagesReport',
  props: {
    data: Object,
    loading: Boolean
  },
  computed: {
    tableData() {
      const report = this.data;

      if (report) {
        const totalVisits = report.totalsForAllResults['ga:visits'];
        const tableData = report.rows.map(row => ({
          pagePath: row[0],
          pageTitle: row[1],
          visits: parseFloat(row[2]).toLocaleString(),
          visitsPercentage: (parseFloat(totalVisits > 0 ? row[2] / totalVisits : 0) * 100).toFixed(1).toLocaleString()
        }));

        return tableData;
      } else {
        return [];
      }
    }
  }
};
</script>

<template>
  <el-table v-loading="loading" :data="tableData">
    <el-table-column :label="$t('Landing Pages')">
      <template slot-scope="scope">
        {{ scope.row.pageTitle }}<br>
        <div class="text-muted text-truncate">
          <small>{{ scope.row.pagePath }}</small>
        </div>
      </template>
    </el-table-column>
    <el-table-column :label="$t('Visits')" prop="visits" width="100" />
    <el-table-column label="%" prop="visitsPercentage" width="100" />
  </el-table>
</template>
